import clsx from 'clsx';
import { Box } from '@alf/uikit';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

const ChatButton = ({ toggleChat, isScrolling }) => {
  return (
    <Box
      justify="center"
      align="start"
      className={`${styles.supportContainer}`}
      onClick={toggleChat}
    >
      <Box
        className={clsx(styles.button, isScrolling && styles.hidden)}
        padding="s"
      >
        <Icon
          name="icons/general/action/live_chat"
          color="bg_color_6"
          size="l"
        />
      </Box>
    </Box>
  );
};

export default ChatButton;
